export const environment = {
  production: true,
  api_domain: 'api.imagebase.pro',
  api_url: 'https://api.imagebase.pro/api/',
  plugins: [],
  facebook: 'https://www.facebook.com/videosense.net',
  instagram: 'https://www.instagram.com/videosense.net',
  twitter: 'https://x.com/',
  app_store: 'https://apps.apple.com/',
  google_play: 'https://play.google.com/store/',
  support_email: 'support@videosense.net',
  web: {
    client_id:
      '1017377505039-ntf200h89qgrphq7ua8utguurnoaos56.apps.googleusercontent.com',
    redirect_uri: 'https://videosense.net/auth/check-oauth-token',
  },
  appToken: 'XqwGevO9dMhnuQ3xyo1704sKKOcJlTsWoKLV0Nccfas',
};
